module.exports = __webpack_public_path__ + "static/media/removeIcon.21788f7a.svg";